import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  "<ul> <li>To conduct two training programs (one week) per year on RS &amp; GIS fundamentals and state of art with 25 participants per batch (2017-18 to 2023-24)&nbsp;</li> </ul> <ul> <li>To conduct two customized training programs (two weeks) per year on RS &amp; GIS applications in water resources management with 25 participants per batch (2017-18 to 2023-24)&nbsp;</li> </ul> <ul> <li>Hand Holding/Technical&nbsp;&nbsp; Support&nbsp;&nbsp; of&nbsp;&nbsp; Satellite/GIS&nbsp;&nbsp; data&nbsp;&nbsp; handling&nbsp;&nbsp; to&nbsp; &nbsp;States/UTs</li> </ul>";

export default class ETProjTeam extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
   
   >
     <div
      className="carddeck_inner"
       style={{
      
         backgroundColor: colors.background,
       }}
     >
          <Slider />
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Capacity Building{" "}
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
